import request from 'superagent';
import Model from '../model';
import * as actions from './actions'
import { toast } from 'react-toastify';

class Notification extends Model {
    read() {
        return (dispatch) => {
            const url = this.url()
            const token = this.token()

            dispatch(actions.readRequest());
            return request
                .post(`${url}/v1/notification/get`)
                .send({offset: 0})
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    switch(res.statusCode){
                        case 200:
                            const notifications = res.body.notifications

                            dispatch(actions.readSuccess(notifications))
                            break;
                        default:
                            dispatch(actions.readFailure(err, res))
                            toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')

                    }
                })
        }
    }

    setToRead(notificationId){
        return (dispatch) => {
            const url = this.url()
            const token = this.token()
            return request
                .post(`${url}/v1/notification/has_read`)
                .send({
                    notification_id: notificationId
                })
                .set('Authorization', `Bearer ${token}`)
                .accept('application/json')
                .set('Content-Type', 'application/json')
                .end((err, res) => {
                    switch(res.statusCode){
                        case 200:
                            dispatch(actions.setRead(notificationId));
                            break;
                        default:
                            toast.error('Någonting gick fel. Kontakta Jibber så hjälper vi dig!')

                    }
                })
        }
    }

    addNotification(notification){
        return(dispatch) => {
            dispatch(actions.addNotification(notification));
        }
    }
}


export default new Notification();



// WEBPACK FOOTER //
// ./src/model/Notification/model.js